import type { NextPage } from 'next'
// import { useRecoilValue } from 'recoil'
import { useEffect, useRef, useState } from 'react'

import Header from './header'
import Footer from './footer'

// import ThemeState from './store/theme'
// import HeaderNav from './HeaderNav'
// import Breadcrumbs from './Breadcrumbs'
// import LeftSidebar from './LeftSidebar'
// import LeftSidebarDialog from './LeftSidebarDialog'
// import Footer from './Footer'


const Layout: NextPage = (props) => {
  // const themeState = useRecoilValue(ThemeState)

  // useEffect(() => {
  //   const body = document.querySelector('body') as HTMLBodyElement
  //   const currentThemeClass = `theme-${themeState}`
  //   const classNames = body.className.split(' ');
  //   classNames.forEach(className => {
  //     if (/theme-\w+/.test(className) && (className !== currentThemeClass)) {
  //         body.classList.remove(className)
  //     }
  //   })
  //   body.classList.add(currentThemeClass)
  // }, [themeState])

  return (
    <div className='flex flex-col h-full'>
      {/* <div className="relative flex h-screen overflow-hidden"> */}
      {/* <LeftSidebarDialog /> */}
      {/* Main column */}
      <Header {...props} />
      <main className="z-0 flex-grow bg-main-bg text-main-text">
        {/* <HeaderNav {...props} /> */}
        {/* <Breadcrumbs /> */}
        <div className='flex h-full'>
          {/* Static sidebar for desktop */}
          {/* <div className="hidden h-full max-w-64 sm:flex sm:flex-shrink-0">
            <LeftSidebar isDialogMode={false} />
          </div> */}
          <div className="flex-1 bg-main-bg">
            {props.children}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default Layout
